import React from 'react';

import type { IconProps } from '@atlaskit/icon';
import CoreEditBulkIcon from '@atlaskit/icon/core/edit-bulk';
import { token } from '@atlaskit/tokens';
import type { IconColor } from '@atlaskit/tokens/css-type-schema';
import { N500 } from '@atlaskit/theme/colors';

type BulkIconProps = {
	strokeColor?: IconColor;
};

export const BulkIcon = ({ strokeColor = token('color.icon', N500) }: BulkIconProps) => (
	<CoreEditBulkIcon
		label=""
		spacing="spacious"
		color={strokeColor}
		LEGACY_primaryColor={strokeColor}
		LEGACY_fallbackIcon={OldBulkIcon}
	/>
);

const OldBulkIcon = ({ primaryColor }: IconProps) => (
	<svg fill="none" width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
		<g stroke={primaryColor} strokeWidth="2">
			<path d="M3 9.5l4 4L15.5 5M16 10.5h4M13 14.5h7M7 18.5h13" />
		</g>
	</svg>
);
